import React from 'react'
import { FormattedHTMLMessage, useBreakpoints } from '@web/walter-ui-kit'

import { lang } from './lang'
import styles from './style.module.css'
import PageHeader from '~components/PageLayout/PageHeader'
import { View } from '~constants/buy'
import { useBuyStore } from '~store/buy'
import { useCustomHandleBack } from '~hooks/useCustomHandleBack'

interface Props {
    view: View
}

function BuyHeader({ view }: Props) {
    const {
        data: { headerBackFunction, content },
    } = useBuyStore()
    const { isDesktop } = useBreakpoints()
    const handleBack = useCustomHandleBack({ backFunction: headerBackFunction })

    if (view === View.TxInfo) {
        return <div className={styles.headerMock} />
    }

    return (
        <PageHeader
            rootPage={isDesktop}
            withBackButton
            onBackClick={handleBack}
            title={content || <FormattedHTMLMessage {...lang.header} />}
        />
    )
}

export default BuyHeader
